/**
 * Growth Partner referral capture decisions.
 *
 * Pure, so jest tests them directly. The effect in App.js is only glue —
 * effects are awkward to test and easy to get subtly wrong, and these three
 * rules are the part worth pinning.
 *
 * Public pages are static prerendered HTML served by nginx, so `?ref=` never
 * reaches the backend on its own. This is the only place the code is noticed.
 */

/** Authenticated areas. Attribution inside one could only reassign somebody
 *  who already has a permanent assignment, which must never happen
 *  automatically — only an admin changes an assignment. */
const PRIVATE_PREFIXES = ['/admin', '/client', '/lawyer', '/funder', '/growth-partner'];

export const shouldCaptureReferral = (pathname) => {
  const path = pathname || '/';
  // Segment-boundary match, not startsWith: '/clients-we-serve' and '/lawyers'
  // are public marketing pages and must not be mistaken for the dashboards.
  return !PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
};

export const extractRefCode = (search) => {
  const raw = new URLSearchParams(search || '').get('ref');
  const code = (raw || '').trim();
  return code || null;
};

export const stripRefFromSearch = (search) => {
  const params = new URLSearchParams(search || '');
  params.delete('ref');
  const rest = params.toString();
  return rest ? `?${rest}` : '';
};

export const extractCampaignCode = (search) => {
  const raw = new URLSearchParams(search || '').get('campaign');
  const code = (raw || '').trim();
  return code || null;
};

/** Strip both referral parameters, preserving every other one. */
export const stripReferralParams = (search) => {
  const params = new URLSearchParams(search || '');
  params.delete('ref');
  params.delete('campaign');
  const rest = params.toString();
  return rest ? `?${rest}` : '';
};
